import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { languages } from '@/common/constants'

const LanguageSelector = ({ supportedLanguages = [], value, onChange }) => {
  const { t } = useTranslation()
  const languageOptions = languages(t).filter(lang => supportedLanguages.includes(lang.value))

  return (
    <ComboBox
      label={t('Idioma')}
      menuItems={languageOptions}
      value={value}
      handleChange={e => onChange(e.target.value)}
    />
  )
}

export default LanguageSelector
